import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select, { components } from 'react-select';
import './schedule.scss';
import { useNavigate } from 'react-router-dom';
import { getClassAndAffiliation, getFaculties, getSchedule, getStudents, getSubjects, getSections, addSchedule, editSchedule, deleteClass, activateClass, resetClassAndAffiliation } from '../../Redux/ActionCreators/scheduleAction';
import { getChapters, getTopics } from '../../Redux/ActionCreators/manageContentAction';
import { trackUserLogin } from '../../Redux/ActionCreators/layoutAction';
import { Modal } from 'react-bootstrap';

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};

function AddClass(){
    const [initialKey, setIntialKey] = useState(0);
    const [subject, setSubject] = useState('');
    const [subjectError, setSubjectError] = useState('');
    const [sectionsError, setSectionsError] = useState('');
    const [activeTab, setActiveTab] = useState('sections'); // 'sections' or 'students'
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    const [openPopupMsg, setOpenPopupMsg] = useState(false);

    const navigate = useNavigate();
    
    const [addList, setAddList] = useState([{ key: 0, 
      title: '', 
      date: '',
      fromTime: '',
      toTime: '',
      subject: '',
      chapter: '',
      topic: '',
      faculty: '',
      sections: [],
     }])
    const dispatch = useDispatch();

    const { subjectList, classAndAffiliation, faculties, sectionsList, studentsList } = useSelector(state => state.schedule);
    const { chapterList, topicsList } = useSelector(state => state.manageContent);

    useEffect(() => {
        dispatch(getSubjects());
        dispatch(resetClassAndAffiliation())
    }, []);

    const goToSchedule = () => {
        navigate(-1);
    }

    const selectStudents = (selectedOptions) => {
        setSelectedStudents(selectedOptions);
        setSectionsError('');
    };

    const selectSections = (selectedOptions) => {
        setSelectedSections(selectedOptions);
        setSectionsError('');
    };

    const selectSubject = async(e) => {
        setSubject(e);
        setSubjectError('');
        setSelectedSections([]);
        setSelectedStudents([]);
        await dispatch(getChapters(e.value));
        const classAffiliation = await dispatch(getClassAndAffiliation(e.value));
        if(!classAffiliation.payload.class){
            setOpenPopupMsg(true);
        } else {
            await dispatch(getSections(classAffiliation.payload.class._id));
            await dispatch(getStudents(classAffiliation.payload.class._id));
        }
        await dispatch(getFaculties(classAffiliation.payload.affiliation._id, e.value))
        setAddList(prev => prev.map(item => ({
            ...item,
            sections: [],
            students: [],
            title: '',
            chapter: '',
            topic: '',
            errors: {}
        })))
    }

    const selectChapter = async (selectedOption, index) => {
        setAddList(prev => 
            prev.map((item, i) => 
                i === index ? { 
                    ...item, 
                    chapter: selectedOption,
                    topic: '',
                    errors: {
                        ...(item.errors || {}),
                        chapter: ''
                    }
                } : item
            )
        );
        await dispatch(getTopics(selectedOption.value));
    }

    const selectTopic = async (selectedOption, index) => {
        setAddList(prev => 
            prev.map((item, i) => 
                i === index ? { 
                    ...item, 
                    topic: selectedOption,
                    title: selectedOption.label,
                    errors: {
                        ...(item.errors || {}),
                        topic: ''
                    }
                } : item
            )
        );
    }

    const selectFaculty = (selectedOption, index) => {
        setAddList(prev => 
            prev.map((item, i) => 
                i === index ? 
                { ...item, faculty: selectedOption,
                    errors: {
                        ...(item.errors || {}),
                        faculty: ''
                    }
                } : item
            )
        );
    }

    const addRow = () => {
        setIntialKey(initialKey + 1);
        setAddList(addList.concat([{ key: initialKey + 1, title: '', date: '', fromTime: '', toTime: '', chapter: '', topic: '', faculty: '', subject: '' }]));
    }

    const removeAddList = (idx) => {
        setAddList(addList.filter((s, index) => idx !== index));
        addList.forEach(el => {
            if (idx < el.key) {
                el.key = el.key - 1
            }
        })
    };

    const handleInputChange = (id, field, value) => {
        setAddList(prev =>
            prev.map(row =>
                row.key === id ? { 
                    ...row, 
                    [field]: value,
                    errors: {
                        ...(row.errors || {}),
                        [field]: ''
                    }
                } : row
            )
        );
    };

    const checkDisabled = () => {
        if (!subject) return true;
        if(selectedSections.length === 0 && selectedStudents.length === 0) return true;

        return addList.some(row => {
            return !row.title ||
                   !row.chapter || 
                   !row.topic ||
                   !row.date
        });
    }

    const saveClass = async () => {
        if (!subject) {
            setSubjectError('Please select a subject');
            return;
        }

        // Validate all rows
        const updatedRows = addList.map(row => {
            const errors = {};
            if (!row.title) errors.title = 'Class name is required';
            if (!row.chapter) errors.chapter = 'Chapter is required';
            if (!row.topic) errors.topic = 'Topic is required';
            if (!row.date) errors.date = 'Date is required'
            
            // Validate that toTime is after fromTime
            if (row?.fromTime && row?.toTime) {
                const fromTime = new Date(`1970-01-01T${row.fromTime}`);
                const toTime = new Date(`1970-01-01T${row.toTime}`);
                
                if (fromTime >= toTime) {
                    errors.toTime = 'End time must be after start time';
                }
            }

            return { ...row, errors };
        });

        // Check if any errors exist
        const hasErrors = updatedRows.some(row => Object.keys(row.errors || {}).length > 0);
        
        if (hasErrors) {
            setAddList(updatedRows);
            return;
        } else if (selectedSections.length === 0 && selectedStudents.length === 0) {
            setSectionsError('Please select at least one section or student');
            return;
        }
        try {
            const classesToSave = addList.map(row => ({
                title: row.title,
                date: row.date,
                from: row.fromTime,
                to: row.toTime,
                faculty_id: localStorage.getItem('role') === 'faculty' ? JSON.parse(localStorage.getItem('profileDetails'))._id : row.faculty.value,
                subject_id: subject.value,
                chapter_id: row.chapter.value,
                topic_id: row.topic.value,
                classroom_id: classAndAffiliation.class._id,
                affiliation_id: classAndAffiliation.affiliation._id,
                ...(activeTab === 'sections' ? { section_ids: selectedSections.map(st => st.value) } : { student_ids: selectedStudents.map(st => st.value) }),
            }));
            await dispatch(addSchedule(classesToSave));
            navigate('/schedule');
        } catch (error) {
            console.error('Error saving classes:', error);
            alert('An error occurred while saving classes');
        }
    }
    return(
        <div className='add-form'>
             <div className='add-schedule-form'>
                <div className='add-header'>
                    <img onClick={goToSchedule} src='/images/back1.svg' alt='' />
                    <p>Add Class</p>
                </div>
                <div className='form-inputs'>
                    <p>Fields marked * are mandatory</p>
                    <div className='row mt-1'>
                        <div className='col-lg-5'>
                            <div className='my-2'>
                                <label>Subject*
                                </label>
                                <Select
                                    components={{ DropdownIndicator }}
                                    placeholder='Select Subject'
                                    value={subject}
                                    onChange={selectSubject}
                                    options={subjectList}
                                />
                                <span>{subjectError}</span>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='my-2'>
                                <label>Class*
                                </label>
                                <input
                                    className='form-control mt-2'
                                    type='text'
                                    value={classAndAffiliation?.class ? `Class ${classAndAffiliation.class.class}` : ''}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='my-2'>
                                <label>Affiliation*
                                </label>
                                <input
                                    className='form-control mt-2'
                                    type='text'
                                    value={classAndAffiliation?.affiliation?.name || ''}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='details-row'>
                    {
                        addList !== undefined && addList.map((items, index) => {
                            return (
                                <div className='schedule-row' key={index}>
                                    {/* <div className="row-index">{index + 1}</div> */}
                                    <div className="row-content">
                                        <div className='row'>
                                            <div className='col-lg-3 '>
                                                <div className='form-group mt-2'>
                                                    <label>Chapter*
                                                    </label>
                                                    <Select
                                                        className={items.errors?.chapter ? 'is-invalid' : ''}
                                                        components={{ DropdownIndicator }}
                                                        placeholder='Select Chapter'
                                                        value={items.chapter || null}
                                                        onChange={(e) => selectChapter(e, index)}
                                                        options={chapterList.map(chapter => ({
                                                            value: chapter._id,
                                                            label: chapter.name
                                                        }))}
                                                        classNamePrefix="select"
                                                        isDisabled={!subject }
                                                    />
                                                    {items.errors?.chapter && <div className="invalid-feedback d-block">{items.errors.chapter}</div>}
                                                </div>
                                            </div>
                                            
                                            <div className='col-lg-9'>
                                                <div className='row'>
                                                    <div className='col-lg-3 '>
                                                        <div className='form-group mt-2'>
                                                            <label>Topic*
                                                            </label>
                                                            <Select
                                                                className={items.errors?.topic ? 'is-invalid' : ''}
                                                                components={{ DropdownIndicator }}
                                                                placeholder='Select Topic'
                                                                value={items.topic || null}
                                                                onChange={(e) => selectTopic(e, index)}
                                                                options={topicsList.map(item => ({
                                                                    label: item.name,
                                                                    value: item._id
                                                                }))}
                                                                classNamePrefix="select"
                                                                isDisabled={!subject || !items.chapter}
                                                            />
                                                            {items.errors?.topic && <div className="invalid-feedback d-block">{items.errors.topic}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-3 '>  
                                                        <div className='form-group mt-2'>
                                                            <label>Class Name*
                                                            </label>
                                                            <input 
                                                                className={`form-control mt-2 text-capitalize ${items.errors?.title ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder='Class Name'
                                                                value={items.title}
                                                                onChange={e => handleInputChange(index, "title", e.target.value)}
                                                                disabled={!subject}
                                                            />
                                                            {items.errors?.title && <div className="invalid-feedback d-block">{items.errors.title}</div>}
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-3 '>  
                                                        <div className='form-group mt-2'>
                                                            <label>Date*
                                                            </label>
                                                            <input 
                                                                className={`form-control mt-2 text-capitalize ${items.errors?.date ? 'is-invalid' : ''}`} 
                                                                type="date" 
                                                                placeholder='Select Date'
                                                                value={items.date}
                                                                onChange={e => handleInputChange(index, "date", e.target.value)}
                                                                onClick={(e) => e.target.showPicker()}
                                                                disabled={!subject}
                                                            />
                                                            {items.errors?.date && <div className="invalid-feedback d-block">{items.errors.date}</div>}
                                                        </div>
                                                    </div>
                                                    {!(localStorage.getItem('role') === 'faculty') && 
                                                    <div className='col-lg-3 ' style={{paddingRight: '30px'}}>
                                                        <div className='form-group mt-2'>
                                                            <label>Faculty
                                                            </label>
                                                            <Select
                                                                className={items.errors?.faculty ? 'is-invalid' : ''}
                                                                components={{ DropdownIndicator }}
                                                                placeholder='Select Faculty'
                                                                value={items.faculty || null}
                                                                onChange={(e) => selectFaculty(e, index)}
                                                                options={faculties}
                                                                classNamePrefix="select"
                                                                isDisabled={!subject}
                                                            />
                                                            {items.errors?.faculty && <div className="invalid-feedback d-block">{items.errors.faculty}</div>}
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            {/* <div className='col-lg-12'>
                                                <div className='row'>
                                                    
                                                </div>
                                            </div> */}
                                            
                                            {
                                                index === 0 ? null : <button
                                                    type="button"
                                                    onClick={() => removeAddList(index)}
                                                    className="delete-row"
                                                ><img src="/images/delete-icon.svg" alt='' /></button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    <button className='add-row' onClick={() => addRow()}>Add row</button> 
                </div>
                <div className='select-batches'>
                    <div className='tabs-container mb-3'>
                        <div 
                            className={`tab ${activeTab === 'sections' ? 'active' : ''}`}
                            onClick={() => setActiveTab('sections')}
                        >
                            Sections
                        </div>
                        <div 
                            className={`tab ${activeTab === 'students' ? 'active' : ''}`}
                            onClick={() => setActiveTab('students')}
                        >
                            Students
                        </div>
                    </div>
                    
                    {activeTab === 'sections' ? (
                        <>
                            <label>Select Sections*</label>
                            <Select
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="select"
                                components={{ DropdownIndicator }}
                                placeholder='Select Sections'
                                options={sectionsList || []}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={trackUserLogin}
                                isClearable={true}
                                isSearchable={true}
                                value={selectedSections}
                                onChange={selectSections}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.value}
                                isDisabled={!subject}
                            />
                        </>
                    ) : (
                        <>
                            <label>Select Students*</label>
                            <Select
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="select"
                                components={{ DropdownIndicator }}
                                placeholder='Select Students'
                                options={studentsList || []}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={trackUserLogin}
                                isClearable={true}
                                isSearchable={true}
                                value={selectedStudents}
                                onChange={selectStudents}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.value}
                                isDisabled={!subject}
                            />
                        </>
                    )}
                    <span>{sectionsError}</span>
                </div>
                <div className='save-btn'>
                    <button 
                        className={`btn ${checkDisabled() ? 'btn-secondary' : 'btn-primary'}`}
                        onClick={saveClass}
                    >
                        Save
                    </button>
                    <button 
                        className="btn btn-outline-secondary" 
                        onClick={goToSchedule}
                    >
                        Cancel
                    </button>
                </div>
            </div> 
            <Modal show={openPopupMsg} onHide={() => setOpenPopupMsg(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>No Class Assigned</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    No class has been assigned to this subject. Please change the subject.
                </Modal.Body>
                <Modal.Footer>
                    <button 
                    className="btn btn-primary" 
                    onClick={() => setOpenPopupMsg(false)}
                    >
                    OK
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AddClass;